import * as React from 'react';
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  EditButton,
  TextInput,
  required,
  useTranslate,
  useLocaleState,
  useEditContext,
} from 'react-admin';

import EmptyList from '../components/misc/EmptyList';
import SourceLanguageBanner from '../components/form/SourceLanguageBanner';
import { useSourceLanguage } from '../hooks/useSourceLanguage';
import { RichTextInput } from 'ra-input-rich-text';

const entity = 'pages';

/** Web /kurumsal/[slug] ile aynı id kullanılır */
export const PageList = (props) => {
  const translate = useTranslate();
  const [locale] = useLocaleState();
  const localeTitleKey = locale === 'tr' ? 'title.tr' : 'title.en';

  return (
    <List
      {...props}
      title={translate('pages.title', { _: 'Sabit Sayfalar' })}
      empty={<EmptyList entity={entity} />}
    >
      <Datagrid rowClick="edit">
        <TextField source="id" label="ID (slug)" />
        <TextField
          source={localeTitleKey}
          label={translate('pages.page_title', { _: 'Sayfa Başlığı' })}
        />
        <EditButton />
      </Datagrid>
    </List>
  );
};

const PageFormFields = ({ isEdit = false, record }) => {
  const translate = useTranslate();
  const { localizedSource } = useSourceLanguage({ isEdit, record });

  return (
    <>
      <SourceLanguageBanner isEdit={isEdit} record={record} />
      <TextInput
        source="id"
        label="ID (web slug)"
        disabled={isEdit}
        helperText={isEdit ? undefined : 'Örn: kvkk, gizlilik, sozlesmeler-ve-politikalar'}
        validate={required()}
      />
      <TextInput
        source={localizedSource('title')}
        label={translate('pages.page_title', { _: 'Sayfa Başlığı' })}
        fullWidth
      />
      <RichTextInput
        source={localizedSource('content')}
        label={translate('pages.content', { _: 'İçerik' })}
        validate={required()}
        fullWidth
      />
    </>
  );
};

const PageEditForm = () => {
  const { record } = useEditContext();
  return (
    <SimpleForm redirect={`/${entity}`}>
      <PageFormFields isEdit record={record} />
    </SimpleForm>
  );
};

export const PageEdit = (props) => {
  const translate = useTranslate();
  return (
    <Edit
      title={translate('pages.edit_page', { _: 'Sayfayı Düzenle' })}
      {...props}
      transform={(data, { previousData }) => ({
        ...data,
        sourceLang: previousData?.sourceLanguage || 'tr',
      })}
    >
      <PageEditForm />
    </Edit>
  );
};

export const PageCreate = (props) => {
  const translate = useTranslate();
  const [locale] = useLocaleState();
  return (
    <Create
      title={translate('ra.action.create', { _: 'Oluştur' })}
      {...props}
      transform={(data) => ({
        ...data,
        sourceLang: locale || 'tr',
      })}
    >
      <SimpleForm redirect={`/${entity}`}>
        <PageFormFields isEdit={false} />
      </SimpleForm>
    </Create>
  );
};
